import { queryOptions } from "@tanstack/react-query";
import { withRequestDeadline } from "@softmax/observatory-client/request-signal";
import {
  DEFAULT_BACKEND_FETCH_TIMEOUT_MS,
  parseResponse,
} from "@softmax/observatory-client/transport";
import type { SiteLink } from "./site-links";

export function publicNavigationOptions() {
  return queryOptions({
    queryKey: ["site", "navigation", "public"],
    queryFn: ({ signal }) =>
      fetch("/api/navigation/coworlds", {
        signal: withRequestDeadline(signal, DEFAULT_BACKEND_FETCH_TIMEOUT_MS),
      }).then((response) => parseResponse<SiteLink[]>(response)),
    staleTime: 60_000,
  });
}
